import { DiamondsFour } from '@phosphor-icons/react';

export default DiamondsFour;
